module.exports = __webpack_public_path__ + "img/trelos.526ac5f6.png";